import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

export function useExpense(id) {
  return useQuery({
    queryKey: ['finance', 'expense', id],
    queryFn: async () => {
      const { data } = await api.get(`/finance/expenses/${id}`);
      return data?.expense || data?.data || data;
    },
    enabled: !!id
  });
}
